<template>
  <FullPage>
    <Webview>
      <Header title="頻道成員列表" :close="back"></Header>
      <div class="member_frame _fill">
        <div class="member_ctn" v-for="data in dataList">
          <div class="image_box _avatar" :class="{default: !data.imageUrl}">
            <div v-if="data.imageUrl" class="image" :style="{backgroundImage: `url(${data.imageUrl})`}"></div>
          </div>
          <div class="name">{{data.userName}}</div>
        </div>
      </div>
    </Webview>
    <Watch v-if="channel" :callback="init" />
  </FullPage>
</template>

<script>
//api
import { getChannelMembers } from "@/api/channel";
export default {
  mixins: [
    require("@mix/channel").default,
    require("@mix/webview").default
  ],
  data() {
    return {
      ready: false,
      dataList: []
    }
  },
  methods: {
    back() {
      this.$router.replace({ path: `/channel/room/${this.channelID}` });
    },
    init() {
      this.ready = true;
      this.getData();
    },
    getData() {
      if (!this.ready) return;
      
      getChannelMembers(this.channelID).then(res => {
        this.dataList = res.data.map(data => {
          data.imageUrl = data.userImages[0]?.url;
          return data;
        });
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.member_frame {
  padding: 0.8rem 0;
  .member_ctn {
    display: flex;
    align-items: center;
    padding: 0.6rem 1rem;
  }
  .image_box {
    @include image-box(1.6rem);
    margin-right: 0.6rem;
  }
  .name {
    font-size: 80%;
  }
}
</style>